<script lang="ts">
  import { Button, Card, CardBody, Col, Row } from "sveltestrap";
  import { navigate } from "svelte-routing";
import Fa from "svelte-fa";
import { faAward, faBookReader, faMoneyBillWave, faQuestion, faUser, faUsers } from "@fortawesome/free-solid-svg-icons";
</script>

<main>
  <h1>EDITOR-IN-CHIEF</h1>
  <div class="d-flex flex-column instructions mt-3">
    You are the new Editor-in-Chief of the local newspaper. Your job is to read all the news tips for
    the day and decide which stories to publish. Choose wisely, for our paper's
    profitability hangs in the balance!

    <h3 class="mt-3">How to Play</h3>
    <p>
      On the left, you'll see your newspaper's stats and the interests of your audience.
      On the right, you'll see three news tips each turn. Click a news tip, then pick a
      journalist to write it. Journalists will level up in topics they write about. When
      you've decided what to publish, click "Next Turn" in the upper right corner.
    </p>

    <div class="display-6 d-grid">
      <Button
        size="lg"
        color="dark"
        class="mt-3 sans d-block"
        on:click={() => navigate("/play")}
      >START GAME!</Button>
      <Button
        size="lg"
        color="dark"
        class="mt-3 sans"
        outline
        on:click={() => navigate("/credits")}
      >CREDITS</Button>
    </div>

    <Row class="mt-5">
      <Col>
        <Card class="h-100 text-center">
          <CardBody>
            {#if localStorage.getItem("moneyAchievement")}
              <div class="display-4">
                <Fa icon={faMoneyBillWave} />
              </div>
              Earn $500 in one game
            {:else}
              <div class="display-4 opacity-50">
                <Fa icon={faQuestion} />
              </div>
            {/if}
          </CardBody>
        </Card>
      </Col>
      <Col>
        <Card class="h-100 text-center">
          <CardBody>
            {#if localStorage.getItem("subsAchievement")}
              <div class="display-4">
                <Fa icon={faBookReader} />
              </div>
              Gain 5,000 subscribers in one game
            {:else}
              <div class="display-4 opacity-50">
                <Fa icon={faQuestion} />
              </div>
            {/if}
          </CardBody>
        </Card>
      </Col>
      <Col>
        <Card class="h-100 text-center">
          <CardBody>
            {#if localStorage.getItem("ratingAchievement")}
              <div class="display-4">
                <Fa icon={faAward} />
              </div>
              End a game with a 4 or 5 star rating
            {:else}
              <div class="display-4 opacity-50">
                <Fa icon={faQuestion} />
              </div>
            {/if}
          </CardBody>
        </Card>
      </Col>
    </Row>
  </div>
</main>

<style>
  main {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1em;
    margin: 0 auto;
    font-family: "Roboto Slab";
  }

  h1 {
    text-align: center;
    margin: 0;
    font-family: "Barlow Condensed";
    text-transform: uppercase;
    font-size: 10em;
    font-weight: bold;
    line-height: 0.9;
  }

  .instructions {
    max-width: 75%;
  }

  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }
</style>
